import { useTranslations } from "../../utils/use-t"
import { RenderPendingApprovalCard } from "./-approval-cards/completed-approval-node"
import { SuspenseWithErrorBoundary } from "../../-components/suspense"
import { DefaultModal } from "../../-components/default-modal"
import {
  AbsenceRequestViewmodel,
  ApprovalAndWorkflowNode,
} from "../../@client/Theasoft_Absences"

export function ApprovalStepDetailsModal({
  currentApprovalInfo,
  approvalNode,
  onApproveClicked,
  onClose,
  leaveRequestId,
}: {
  currentApprovalInfo: AbsenceRequestViewmodel
  approvalNode: ApprovalAndWorkflowNode | null
  onClose: () => void
  onApproveClicked: (() => void) | undefined
  leaveRequestId: number
}) {
  const ts = useTranslations()
  return (
    <SuspenseWithErrorBoundary>
      <DefaultModal
        opened={approvalNode !== null}
        onClose={onClose}
        title={ts.absences.t("ApprovalStep")}
      >
        {approvalNode !== null ? (
          <ApprovalStepModalDetails
            leaveRequestId={leaveRequestId}
            currentApprovalInfo={currentApprovalInfo}
            approvalNode={approvalNode}
            onClose={onClose}
            onApproveClicked={onApproveClicked}
          />
        ) : null}
      </DefaultModal>
    </SuspenseWithErrorBoundary>
  )
}

function ApprovalStepModalDetails({
  approvalNode,
  onClose,
  currentApprovalInfo: data,
  leaveRequestId,
}: {
  approvalNode: ApprovalAndWorkflowNode
  currentApprovalInfo: AbsenceRequestViewmodel
  onClose: () => void
  onApproveClicked: (() => void) | undefined
  leaveRequestId: number
}) {
  return (
    <RenderPendingApprovalCard
      leaveRequestId={leaveRequestId}
      onChanged={onClose}
      node={approvalNode}
      canChangeApprovers={
        data.permissions.canChangeApprovers &&
        (approvalNode.workflowNode.status.Case === "Pending" ||
          approvalNode.workflowNode.status.Case === "Active")
      }
      canResolvePersonUsers={data.permissions.canResolvePersonUsers}
      isWorkflowFinished={data.workflow.result.Case !== "Pending"}
    />
  )
}
